import { render } from "./AddQrCode.vue?vue&type=template&id=0c0f212e&scoped=true"
import script from "./AddQrCode.vue?vue&type=script&lang=js"
export * from "./AddQrCode.vue?vue&type=script&lang=js"

import "./AddQrCode.vue?vue&type=style&index=0&id=0c0f212e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0f212e"]])

export default __exports__